// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const blocknoteContentToText = (value) => {
    if (Array.isArray(value)) {
        return value.map(blocknoteContentToText).filter(Boolean).join('\n');
    }
    if (typeof value === 'object') {
        return [
            value.type === 'mention'
                ? '@' + value.props?.name
                : typeof value.text === 'string'
                    ? value.text
                    : Array.isArray(value.content)
                        ? value.content.map(blocknoteContentToText).filter(Boolean).join('')
                        : '',
            ...(Array.isArray(value.children)
                ? value.children.map(blocknoteContentToText)
                : []),
        ]
            .filter(Boolean)
            .join('\n');
    }
    return '';
};
//# sourceMappingURL=blocknoteContentToText.js.map